<div class="content">
  <div class="filters-row">
    <app-input [formControl]="searchValueControl" [placeholder]="'labels.search'|translate">
      <i class="pi pi-search"></i>
    </app-input>

    <button pButton (click)="showModalAddDriver()" class="header__filters__submit">
      <i class="pi pi-plus" pButtonIcon></i>
      <span pButtonLabel>
        {{ "addDriver" | translate }}
      </span>
    </button>

    <span class="refresh-info">
      <i class="pi pi-spin pi-spinner"></i>
      {{ 'autoRefreshData' | translate}}
    </span>
  </div>

  <div #containerList class="content__list-wrapper">
    <app-tachograph-files-list
      (onChangeDownloadMode$)="onChangeDownloadMode($event)"
      (openFiles$)="openFiles$.emit($event)"
      [isLoading]="isLoadingInit()"
      [searchValueControl]="searchValueControl.value"
      [isCheckedAll]="isCheckedAll"
      [list]="filesDriverFasade.driverList()"
      [selectedItems]="selectedItems()"
      (forceFile$)="forceFile($event)"
      (onToggleSelectedAll$)="onChangeValueCheckedAll($event)"
      (onSelectItem$)="onCheckedItem($event)"
      [isDriverMode]="true"
    ></app-tachograph-files-list>
  </div>

  <div class="content__footer">
    <div class="left">
      <ng-container *ngIf="selectedItems().length">
        <span class="count-checked-row"
          >{{ selectedItems().length }}
          {{ "labels.selected" | translate }}</span
        >
        <!-- <button pButton (click)="deleteDrivers()" [loading]="isDeletingItems()" severity="secondary" class="button-submit-checked-row">
          <i class="pi pi-trash" pButtonIcon></i>
          <span pButtonLabel>
            {{ "Usuń" | translate }}
          </span>
        </button> -->
        <button pButton severity="secondary" class="button-submit-checked-row">
          <i class="pi pi-cloud-download" pButtonIcon></i>
          <span pButtonLabel>
            {{ "getRemote" | translate }}
          </span>
        </button>
      </ng-container>
    </div>
  </div>
</div>

<p-dialog [header]="'addDriver'|translate" [modal]="true" [(visible)]="visibleForm" [style]="{ width: '720px' }">
  <div class="add-vehicle-form">
    <p-treeselect
      [(ngModel)]="selectedDriverForm"
      [options]="driverTreeList()"
      [filter]="true"
      scrollHeight="200px"
      [placeholder]="'selectDrivers' | translate"
      selectionMode="checkbox"
    />

    <span>{{ 'listOfAddedDrivers' | translate}}:</span>
    <div class="add-vehicle-form__list-of-addeed">
      <p-chip *ngFor="let item of filesDriverFasade.driverList()" [label]="item.Driver.FN + ' ' + item.Driver.LN" />
    </div>

    <div class="flex justify-end gap-2 add-vehicle-form__actions">
      <p-button [label]="'primeng.cancel' | translate" severity="secondary" (click)="visibleForm = false" />
      <p-button [label]="'labels.add' | translate" (click)="onAddDrivers()" [loading]="isSavingForm()" />
    </div>
  </div>
</p-dialog>
